exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".initiativetable-cssmodule-initiativetable-component-OOSrP{border:1px solid red}.initiativetable-cssmodule-table-container-39ciN{min-height:500px}", ""]);

// exports
exports.locals = {
	"initiativetable-component": "initiativetable-cssmodule-initiativetable-component-OOSrP",
	"table-container": "initiativetable-cssmodule-table-container-39ciN"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/BrowseIdeas/initiativetable.cssmodule.scss
// module id = 599
// module chunks = 0